export default "__VITE_ASSET__DYedNb7M__"